import PropTypes from 'prop-types';
export const tableOfContentsPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Links - strings
   */
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }))
};